// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.s-flexdrive-vehicle__tagged[data-v-1b0e3fc2] {
  background-color: var(--1b0e3fc2-highlightBgColor);
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/js/vue/apps/FlexDriveVehicle.vue","webpack://./FlexDriveVehicle.vue"],"names":[],"mappings":"AACA;EACE,kDAAA;EACA,YAAA;ACAF","sourcesContent":["\r\n.s-flexdrive-vehicle__tagged {\r\n  background-color: v-bind(highlightBgColor);\r\n  color: white;\r\n}\r\n",".s-flexdrive-vehicle__tagged {\n  background-color: v-bind(highlightBgColor);\n  color: white;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
